import React, { Component } from 'react';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import EditForm from './shared/EditForm';

class CreateForm extends Component {
  state = {
    loading: false,
  };

  handleSubmit = workspace => {
    this.setState({ loading: true, error: null }, () => {
      request
        .post(routes.WORKSPACES.INDEX, { workspace })
        .then(response => {
          this.setState({ loading: false }, () => {
            this.props.onCreate(response.workspace);
            this.props.onDismiss();
          });
        })
        .fail(({ responseJSON }) => {
          this.setState({ loading: false, error: responseJSON });
        });
    });
  };

  render() {
    const { loading, error } = this.state;
    return (
      <EditForm loading={loading} error={error} onSubmit={this.handleSubmit}>
        <EditForm.Cancel onClick={this.props.onDismiss} />
        <EditForm.Submit>{t('workspaces.create_workspace')}</EditForm.Submit>
      </EditForm>
    );
  }
}

export default CreateForm;
